var $12c51030c18c1e33$exports = {};
if (null) null.accept();
const $12c51030c18c1e33$var$mapContainer = document.getElementById("map");
const $12c51030c18c1e33$var$ipAddress = document.querySelector(".ipAddress");
const $12c51030c18c1e33$var$locationEl = document.querySelector(".location");
const $12c51030c18c1e33$var$timezone = document.querySelector(".timezone");
const $12c51030c18c1e33$var$isp = document.querySelector(".isp");
const $12c51030c18c1e33$var$input = document.querySelector("input");
const $12c51030c18c1e33$var$send = document.querySelector(".send");
const $12c51030c18c1e33$var$ipAddressContainer = document.querySelector(".ip--container");
const $12c51030c18c1e33$var$locationContainer = document.querySelector(".location--container");
const $12c51030c18c1e33$var$timezoneContainer = document.querySelector(".timezone--container");
const $12c51030c18c1e33$var$ispContainer = document.querySelector(".isp--container");
const $12c51030c18c1e33$var$container = document.querySelector(".displayed--information--container");
let $12c51030c18c1e33$var$paragraph = document.querySelector(".errormsg");
let $12c51030c18c1e33$var$popup = "Your current location\uD83D\uDCCC";
let $12c51030c18c1e33$var$lat;
let $12c51030c18c1e33$var$lng;
const $12c51030c18c1e33$var$validIpTest = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
const $12c51030c18c1e33$var$validDomainTest = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
const $12c51030c18c1e33$var$executeCode = ()=>{
    // remove the container hidden classes
    $12c51030c18c1e33$var$ipAddressContainer.classList.add("hidden");
    $12c51030c18c1e33$var$locationContainer.classList.add("hidden");
    $12c51030c18c1e33$var$timezoneContainer.classList.add("hidden");
    $12c51030c18c1e33$var$ispContainer.classList.add("hidden");
    $12c51030c18c1e33$var$paragraph.classList.add("hidden");
    $12c51030c18c1e33$var$container.classList.remove("h-[100px]");
    const value = $12c51030c18c1e33$var$input.value;
    if (!value) return;
    if ($12c51030c18c1e33$var$validIpTest.test(value)) $12c51030c18c1e33$var$fetchData(value, "");
    else if ($12c51030c18c1e33$var$validDomainTest.test(value)) $12c51030c18c1e33$var$fetchData("", value);
    else {
        $12c51030c18c1e33$var$input.style.border = "1px solid red";
        let value = $12c51030c18c1e33$var$input.value;
        $12c51030c18c1e33$var$input.value = "Please enter a valid ip address or domain name";
        $12c51030c18c1e33$var$input.style.color = "red";
        setTimeout(()=>{
            $12c51030c18c1e33$var$input.style.border = "none";
            $12c51030c18c1e33$var$input.value = value;
            $12c51030c18c1e33$var$input.style.color = "black";
        }, 3000);
        return;
    }
};
$12c51030c18c1e33$var$send.addEventListener("click", $12c51030c18c1e33$var$executeCode);
document.addEventListener("keydown", (e)=>{
    if (e.key === "Enter") $12c51030c18c1e33$var$executeCode();
});
const $12c51030c18c1e33$var$type = new Typed(".auto-type", {
    strings: [
        "please wait...",
        "hang tight!",
        "almost there..."
    ],
    typeSpeed: 100,
    backSpeed: 100,
    loop: true
});
const $12c51030c18c1e33$var$fetchData = async (value, domain)=>{
    try {
        document.querySelector(".loading-element").classList.remove("hidden");
        const baseURL = "https://geo.ipify.org/api/v2/country,city";
        const apiKey = "at_tJ66XQzhcu490QC72T4T9hFmh1IrV"; // Secure this key in backend
        const queryParams = value ? `&ipAddress=${value}` : domain ? `&domain=${domain}` : "";
        const res = await fetch(`${baseURL}?apiKey=${apiKey}${queryParams}`);
        if (!res.ok) throw new Error(`API Error: ${res.status} ${res.statusText}`);
        const data = await res.json();
        console.log("API Response:", data); // Debugging
        if (!data.location || typeof data.location.lat !== "number" || typeof data.location.lng !== "number") {
            console.error("Invalid location data", data);
            $12c51030c18c1e33$var$paragraph.textContent = "Location data not available. Please check the input.";
            $12c51030c18c1e33$var$paragraph.classList.remove("hidden");
            return;
        }
        $12c51030c18c1e33$var$ipAddressContainer.classList.remove("hidden");
        $12c51030c18c1e33$var$locationContainer.classList.remove("hidden");
        $12c51030c18c1e33$var$timezoneContainer.classList.remove("hidden");
        $12c51030c18c1e33$var$ispContainer.classList.remove("hidden");
        $12c51030c18c1e33$var$ipAddress.textContent = data.ip;
        $12c51030c18c1e33$var$locationEl.textContent = `${data.location.city}, ${data.location.country}`;
        $12c51030c18c1e33$var$timezone.textContent = `UTC${data.location.timezone}`;
        $12c51030c18c1e33$var$isp.textContent = data.isp;
        $12c51030c18c1e33$var$popup = `${data.location.city}, ${data.location.country} \u{1F4CC}`;
        $12c51030c18c1e33$var$lat = data.location.lat;
        $12c51030c18c1e33$var$lng = data.location.lng;
        $12c51030c18c1e33$var$mapFunction($12c51030c18c1e33$var$lat, $12c51030c18c1e33$var$lng);
    } catch (err) {
        console.error("Something went wrong:", err.message);
        $12c51030c18c1e33$var$paragraph.textContent = err.message;
        $12c51030c18c1e33$var$paragraph.classList.remove("hidden");
    } finally{
        document.querySelector(".loading-element").classList.add("hidden");
    }
};
let $12c51030c18c1e33$var$map = null;
let $12c51030c18c1e33$var$mapInitialized = false;
let $12c51030c18c1e33$var$marker;
const $12c51030c18c1e33$var$mapFunction = (lat, lng)=>{
    if ($12c51030c18c1e33$var$mapInitialized ? null : $12c51030c18c1e33$var$mapInitialized = true) {
        $12c51030c18c1e33$var$map = L.map($12c51030c18c1e33$var$mapContainer).setView([
            lat,
            lng
        ], 15);
        L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; OpenStreetMap contributors'
        }).addTo($12c51030c18c1e33$var$map);
        $12c51030c18c1e33$var$mapInitialized = true;
    } else $12c51030c18c1e33$var$map.setView([
        lat,
        lng
    ], 15);
    if ($12c51030c18c1e33$var$marker) $12c51030c18c1e33$var$map.removeLayer($12c51030c18c1e33$var$marker);
    $12c51030c18c1e33$var$marker = L.marker([
        lat,
        lng
    ]).addTo($12c51030c18c1e33$var$map).bindPopup($12c51030c18c1e33$var$popup).openPopup();
};
navigator.geolocation.getCurrentPosition((position)=>{
    let { latitude: latitude, longitude: longitude } = position.coords;
    $12c51030c18c1e33$var$mapFunction(latitude, longitude);
    $12c51030c18c1e33$var$mapInitialized || ($12c51030c18c1e33$var$mapInitialized = true);
}, (error)=>{
    console.log("something went wrong", error);
});


//# sourceMappingURL=index.0d6a2e43.js.map
